<template>
    <section class="showcase">
    <div class="p-0 sk-margin">
        <div class="col-lg-12 order-lg-1 my-auto showcase-text">
          <h3>SUKIMATCHが</h3>
          <h1 class="lead mb-0">バナー制作のお悩み解決します!</h1>
        </div>

      <div class="row no-gutters sk-margin">
         <!-- Heading Row -->
    <div class="row align-items-center row-margin">
      
      <!-- /.col-lg-8 -->
      <div class="col-lg-6">
        <h1 class="font-weight-light">発注しやすい低価格</h1>
        <p>1件500円からの低価格でいざ発注という際も安心してご発注いただけます。また内容に応じてクリエイターと個別の調整も可能◎低価格とはいえお取引中のサポートも付いておりますので、お気軽にご相談ください！</p>
    
      </div>
      <div class="col-lg-6">
        <img class="img-fluid service-img" src="../assets/img/sukimatch/service1.jpg" alt="">
      </div>
      <!-- /.col-md-4 -->
    </div>
      </div>
    <!-- /.row -->
         <!-- Heading Row -->
         <div class="row no-gutters sk-margin">
    <div class="row align-items-center convert--reserve row-margin">
      <div class="col-lg-6">
        <img class="img-fluid service-img" src="../assets/img/sukimatch/service2.jpg" alt="">
      </div>
      <!-- /.col-lg-8 -->
      <div class="col-lg-6">
        <h1 class="font-weight-light">1点から大量発注まで</h1>
        <p>SUKIMATCHには全国〇〇人のクリエイターがあなたのバナー制作をサポートいたします！自社サイトバナー1点からでも、ECサイト向けの量産依頼まで対応可能です。お客様一人一人にあったご要望に、弊社のクリエーターたちがお答えいたします！</p>
      </div>
      <!-- /.col-md-4 -->
    </div>
         </div>


    <div class="row no-gutters sk-margin">
    <div class="row align-items-center row-margin">
      
      <!-- /.col-lg-8 -->
      <div class="col-lg-6">
        <h1 class="font-weight-light">最短1営業日から納品可能
</h1>
        <p>急にバナーが必要に...そんなお客様のお悩みもおまかせ下さい！制作会社への依頼とは違い、フレキシブルな働き方のクリエイターとお客様をマッチングできるSUKIMATCHでは24時間いつでも依頼が可能です！
</p>
        
      </div>
      <div class="col-lg-6">
        <img class="img-fluid service-img" src="../assets/img/sukimatch/service3.jpg" alt="">
      </div>
      <!-- /.col-md-4 -->
    </div>
    </div>
    
    <!-- /.row -->
      </div>
  </section>
</template>

<script>
export default {
    
}
</script>

<style>
.sk-margin {
    margin: 30px;
}

.row-margin {
    margin-top: 10px;
    margin-bottom: 10px;
}

.service-img {
    width: 80%;
    height: 80%
}

@media screen and (max-width: 767px) {
  .convert--reserve {
    flex-direction: column-reverse;
  }
 
}

@media screen and (max-width: 576px) {
  .convert--reserve {
    flex-direction: column-reverse;
  }
}

@media screen and (max-width: 1200px) {
  .convert--reserve {
    flex-direction: column-reverse;
  }
}
</style>